// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentButton_root__NWdim"};